<template>
    <div class="home__reviews">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <div class="bg">
                        <h5 class="title text-center">
                            {{ $t("promo.Reviews - heading") }}
                        </h5>
                        <div class="subtitle text-center">
                            {{ $t("promo.Reviews - subheading") }}
                        </div>

                        <div class="swiper-container">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide">
                                    <div class="review-slide d-flex">
                                        <img
                                            class="photo"
                                            src="/images/promo/review_1.jpg"
                                            srcset="
                                                /images/promo/review_1@2x.jpg 2x
                                            "
                                        />
                                        <div class="text">
                                            <strong>{{
                                                $t(
                                                    "promo.Reviews - 1 - heading"
                                                )
                                            }}</strong>
                                            <p>
                                                {{
                                                    $t(
                                                        "promo.Reviews - 1 - info"
                                                    )
                                                }}
                                            </p>
                                            <div class="author">
                                                <strong>
                                                    {{
                                                        $t(
                                                            "promo.Reviews - 1 - name"
                                                        )
                                                    }}
                                                </strong>
                                                <div class="stars">
                                                    <img
                                                        v-for="n in 5"
                                                        :key="n"
                                                        src="/images/promo/review_star.svg"
                                                        alt=""
                                                    />
                                                </div>
                                                <img
                                                    src="/images/promo/google_logo.png"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- /slide -->
                                <div class="swiper-slide">
                                    <div class="review-slide d-flex">
                                        <img
                                            class="photo"
                                            src="/images/promo/review_2.jpg"
                                            srcset="
                                                /images/promo/review_2@2x.jpg 2x
                                            "
                                        />
                                        <div class="text">
                                            <strong>{{
                                                $t(
                                                    "promo.Reviews - 2 - heading"
                                                )
                                            }}</strong>
                                            <p>
                                                {{
                                                    $t(
                                                        "promo.Reviews - 2 - info"
                                                    )
                                                }}
                                            </p>
                                            <div class="author">
                                                <strong>
                                                    {{
                                                        $t(
                                                            "promo.Reviews - 2 - name"
                                                        )
                                                    }}
                                                </strong>
                                                <div class="stars">
                                                    <img
                                                        v-for="n in 5"
                                                        :key="n"
                                                        src="/images/promo/review_star.svg"
                                                        alt=""
                                                    />
                                                </div>
                                                <img
                                                    src="/images/promo/google_logo.png"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- /slide -->
                                <div class="swiper-slide">
                                    <div class="review-slide d-flex">
                                        <img
                                            class="photo"
                                            src="/images/promo/review_3.jpg"
                                            srcset="
                                                /images/promo/review_3@2x.jpg 2x
                                            "
                                        />
                                        <div class="text">
                                            <strong>{{
                                                $t(
                                                    "promo.Reviews - 3 - heading"
                                                )
                                            }}</strong>
                                            <p>
                                                {{
                                                    $t(
                                                        "promo.Reviews - 3 - info"
                                                    )
                                                }}
                                            </p>
                                            <div class="author">
                                                <strong>
                                                    {{
                                                        $t(
                                                            "promo.Reviews - 3 - name"
                                                        )
                                                    }}
                                                </strong>
                                                <div class="stars">
                                                    <img
                                                        v-for="n in 5"
                                                        :key="n"
                                                        src="/images/promo/review_star.svg"
                                                        alt=""
                                                    />
                                                </div>
                                                <img
                                                    src="/images/promo/google_logo.png"
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- /slide -->
                            </div>
                            <div
                                class="swiper-controls d-flex align-items-center justify-content-center"
                            >
                                <div class="swiper-button-prev">
                                    <img
                                        src="/images/promo/chevron-right.svg"
                                        alt=""
                                    />
                                </div>
                                <div class="swiper-pagination"></div>
                                <div class="swiper-button-next">
                                    <img
                                        src="/images/promo/chevron-right.svg"
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

export default {
    data() {
        return {
            swiper: null,
        };
    },
    methods: {
        initSlider() {
            this.swiper = new Swiper(".swiper-container", {
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });
        },
    },
    mounted() {
        this.initSlider();
    },
};
</script>

<style lang="scss">
.home {
    &__reviews {
        .bg {
            background: #f7f9fc;
            border-radius: 8px;
            padding: 24px 32px;
            @media (max-width: 575px) {
                padding: 20px 15px;
                margin-left: -15px;
                margin-right: -15px;
                border-radius: 0;
            }

            .title {
                font-style: normal;
                font-weight: 600;
                font-size: 24px;
                line-height: 28px;
                color: #141430;
            }

            .subtitle {
                font-weight: normal;
                font-size: 15px;
                line-height: 22px;
                color: #959bb5;
                margin-bottom: 28px;
            }

            .swiper-pagination,
            .swiper-button-prev,
            .swiper-button-next {
                position: relative;
            }

            .swiper-controls {
                margin-top: 24px;
            }

            .swiper-pagination {
                margin: 0px 16px;
            }

            .swiper-pagination-bullet {
                background: #cfd6ea;
                width: 11px !important;
                height: 11px !important;
                margin: 0px 5px;
                opacity: 1 !important;

                &.swiper-pagination-bullet-active {
                    background: #9393bf;
                }
            }

            .swiper-button-prev {
                img {
                    transform: scaleX(-1);
                }
            }

            .swiper-button-prev,
            .swiper-button-next {
                background: #ffffff;
                box-shadow: 0px 0px 12px rgba(149, 155, 181, 0.3);
                width: 48px;
                height: 48px;
                min-width: 48px;
                border-radius: 50%;
                margin: 0px 10px;

                &::after {
                    display: none;
                }
            }

            .review-slide {
                @media (max-width: 1280px) {
                    align-items: center;
                }
                @media (max-width: 475px) {
                    flex-direction: column;
                    align-items: flex-start;
                }

                .photo {
                    background: #f7f9fc;
                    border-radius: 8px;
                    width: 260px;
                    height: 260px;
                    margin-right: 42px;
                    min-width: 260px;
                    background-size: cover;
                    background-position: center;

                    @media (max-width: 1280px) {
                        width: 165px;
                        height: 165px;
                        min-width: 165px;
                    }
                    @media (max-width: 475px) {
                        margin-bottom: 20px;
                    }
                }

                .text {
                    font-style: normal;
                    font-weight: 400;
                    font-size: 18px;
                    color: #141430;
                    @media (max-width: 768px) {
                        font-size: 16px;
                    }

                    & > strong {
                        font-weight: 600;
                        display: block;
                        margin-bottom: 10px;
                    }
                }

                .author {
                    strong {
                        font-weight: 600 !important;
                        font-size: 15px;
                        color: #141430;
                        line-height: 1;
                        margin-bottom: 0;
                    }

                    .stars {
                        display: flex;
                        justify-content: flex-start;
                        line-height: 1;
                        margin-bottom: 4px;
                    }
                }
            }
        }
    }
}
</style>
